import { styled } from '@mui/material';

export const ListW = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  @media (max-width: 1023px) {
    flex-direction: column;
    row-gap: 8px;
  }
`;

export const ContainerW = styled('div')`
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};

  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: calc(100% - 38px);
  @media (max-width: 1023px) {
    padding: 8px 8px 20px;
  }
  @media (min-width: 1920px) {
    margin: 0 auto;
  }
`;
